export function roundColumnValue(value, decimalPlaces) {
    if (!value || isNaN(Number.parseFloat(value))) {
        return 0;
    }
    let valueAsNumber = Number.parseFloat(value);
    //return value === 0 ? 0 : value.toFixed(decimalPlaces);
    let returnVal = valueAsNumber === 0 ? 0 : valueAsNumber.toFixed(decimalPlaces);
    return returnVal.toString();
}

export function roundColumnValueToOneDecimalPlace(value) {
    if (!value || isNaN(Number.parseFloat(value))) {
        return 0;
    }
    let valueAsNumber = Number.parseFloat(value);
    let returnVal = valueAsNumber === 0 ? 0 : valueAsNumber.toFixed(1);
    return returnVal.toString();
}

export function roundNumberToTwoDecimalPlace(value) {
    if (!value || isNaN(Number.parseFloat(value))) {
        return 0;
    }
    let valueAsNumber = Number.parseFloat(value);
    let returnVal = valueAsNumber === 0 ? 0 : valueAsNumber.toFixed(2);
    return returnVal;
}
